import axios from 'axios'
import { observer } from 'mobx-react-lite'
import React, { useEffect } from 'react'
import { useAuth } from '../../hooks/useAuth'
import { userIsLoggedIn } from './Authentication'
import FavoriteButon from './FavoriteButton'
import { MediaTypes, MediaTypesType } from './Utils'

export const getGenesisSongFavoriteCount = async (songID) => {
  const resp = await axios.get('/api/v1/song-genesis/favorite-count', {
    params: {
      song_id: songID
    }
  })

  return resp.data.favoriteCount
}

const GenesisFavoriteButton = ({ song_id, height, width, className, white, favorite_count }) => {
  const { user } = useAuth()
  const [selected, setSelected] = React.useState(false)
  const [favoriteCount, setFavoriteCount] = React.useState(favorite_count)

  useEffect(() => {
    setSelected(
      userIsLoggedIn(user) &&
        (user.favorite_genesis_songs ? user.favorite_genesis_songs.indexOf(song_id) > -1 : false)
    )
  }, [user, song_id])

  useEffect(() => {
    if (favoriteCount)
      getGenesisSongFavoriteCount(song_id).then((newFavoriteCount) => {
        setFavoriteCount(newFavoriteCount)
      })
  }, [selected])

  return (
    <div className={'d-inline-flex ' + className}>
      <FavoriteButon
        arpMediaIndex={song_id}
        mediaType={MediaTypes.GENESISSONG as MediaTypesType}
        white
      />
      {favoriteCount !== undefined && favoriteCount > 0 && (
        <p className="ps-1 my-auto" style={{ lineHeight: height, color: white && 'white' }}>
          {favoriteCount}
        </p>
      )}
    </div>
  )
}

GenesisFavoriteButton.defaultProps = {
  white: false
}

export default observer(GenesisFavoriteButton)
